export default __webpack_public_path__ + "20a311abe726f7f126b2d981d39ae158.png";